/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { docsSchema } from "./docsSchema.ts";

export const orgOrganizationsDocsRetrievePathOrgIdSchema = z.uuid();

export const orgOrganizationsDocsRetrieveQueryOrgUnitSchema = z.string().optional();

export const orgOrganizationsDocsRetrieveStatus200Schema = docsSchema;

export const orgOrganizationsDocsRetrieveResponseSchema = orgOrganizationsDocsRetrieveStatus200Schema;
